import { getMartData } from "api/ApiCalls"
import { applyFetcherOptions } from "helpers/martHelpers"
import { type MartFetcherOptions } from "types/ApiTypes"
import type {
  IServerSideGetRowsRequest,
  SortModelItem,
} from "@tokenterminal/ui/DataTable"

// Deprecated

type DataGridSortModelItem = SortModelItem & {
  isSortCaseInsensitive?: boolean
}

type CohortAnalysisGetRowsRequest = Omit<
  IServerSideGetRowsRequest,
  "sortModel"
> & {
  sortModel: Array<DataGridSortModelItem>
}

const DATASET_TABLE = `cohort_analysis`

const PLAIN_SSRM_REQUEST: CohortAnalysisGetRowsRequest = {
  startRow: 0,
  endRow: 100,
  valueCols: [],
  pivotCols: [],
  rowGroupCols: [],
  pivotMode: false,
  groupKeys: [],
  filterModel: {},
  sortModel: [],
}

const DEFAULT_SSRM_REQUEST: CohortAnalysisGetRowsRequest = {
  ...PLAIN_SSRM_REQUEST,
  sortModel: [
    {
      sort: "asc",
      colId: "project_name",
      isSortCaseInsensitive: true,
    },
    {
      sort: "asc",
      colId: "cohort",
    },
  ],
  rowGroupCols: [
    {
      displayName: "Project",
      field: "project_name",
      id: "project_name",
    },
  ],
}

type CohortAnalysisDataBQ = Record<string, string | number>

export async function getCohortAnalysisData<T = Array<CohortAnalysisDataBQ>>(
  body: CohortAnalysisGetRowsRequest = DEFAULT_SSRM_REQUEST,
  opts?: MartFetcherOptions
) {
  if (opts) {
    applyFetcherOptions(body, opts)
  }

  const { data } = await getMartData<T>(DATASET_TABLE, body)

  return data
}
